import { Controller } from '@hotwired/stimulus'

// The deviation-response stepper (ux-design §3.3). A single scrollable form, not
// a wizard. This controller: (1) wires the quick-fill chips into the containment
// and root-cause fields, (2) makes the submit button's label + weight track the
// chosen product disposition (releasing product reads as the consequential
// action it is), and (3) on a failed submit, scrolls the first invalid field
// into view. Required-field gating is the browser's job (HTML `required`); the
// server (DeviationResponseForm) is the source of truth.
export default class extends Controller {
  static targets = ['containment', 'cause', 'submit', 'errors']

  connect () {
    // After a server-side validation failure, jump the manager to the first
    // field that needs attention instead of leaving them at the top of a long
    // scrollable form. Gated on the error summary so a fresh form never scrolls.
    if (!this.hasErrorsTarget) return
    const invalid = this.element.querySelector('input:invalid, textarea:invalid, select:invalid')
    if (!invalid) return
    invalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
    invalid.focus({ preventScroll: true })
  }

  fillContainment (event) {
    this.fill(this.containmentTarget, event.currentTarget.dataset.value)
  }

  fillCause (event) {
    this.fill(this.causeTarget, event.currentTarget.dataset.value)
  }

  // Reflect the chosen disposition on the submit button: its label names the
  // action, and releasing product turns the button red (btn-error) instead of
  // caution-amber (btn-warning).
  updateSubmit (event) {
    if (!this.hasSubmitTarget) return
    const { submitLabel, danger } = event.currentTarget.dataset
    if (submitLabel) this.submitTarget.textContent = submitLabel
    const isDanger = danger === 'true'
    this.submitTarget.classList.toggle('btn-error', isDanger)
    this.submitTarget.classList.toggle('btn-warning', !isDanger)
  }

  // Append the chip text (with a separator if the field already has content) so
  // tapping several chips composes rather than overwrites.
  fill (field, value) {
    field.value = field.value.trim() === '' ? value : `${field.value.trim()}; ${value}`
    field.focus()
  }
}
